import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useFormikContext } from "formik";
import { ThemeType } from "../../../../../redux/constants";
import { selectThemeSettings } from "../../../../../redux/slices/cmsSettingsSlice";
import { selectAllRegistration } from "../../../../../redux/slices/registrationSlice";
import {
    selectAllP2pSettings,
    selectBaseUrl,
} from "../../../../../redux/slices/p2pSettingsSlice";
import RegistrationSummaryHeader from "./RegistrationSummaryHeader";

const ConnectedRegistrationSummaryHeader = () => {
    const { pathname } = useLocation();
    const { values } = useFormikContext();
    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.SUMMARY, state),
    );
    const {
        p2pGeneral: { summaryHeading = "Your Summary" },
    } = themeSettings;
    const {
        classification,
        currentRegistration,
        registrations = [{}],
    } = useSelector(selectAllRegistration);
    const { Classification = [] } = classification;
    const { enableClassifications } = useSelector(selectAllP2pSettings);
    const registration = registrations[0];
    const baseUrl = useSelector(selectBaseUrl);
    const getPrimaryRegistration = () => {
        if (
            currentRegistration === 0 &&
            pathname === `${baseUrl}/form/registration`
        ) {
            return values;
        }
        return registration;
    };
    const { Category = [] } = getPrimaryRegistration();
    const isVisible = enableClassifications
        ? Classification.length > 0
        : Category.length > 0;

    const registrationSummaryHeaderProps = { isVisible, summaryHeading };

    return <RegistrationSummaryHeader {...registrationSummaryHeaderProps} />;
};

export default ConnectedRegistrationSummaryHeader;
